export const headers = [
  {
    name: "Campus",
    col: 0,
  },
  {
    name: "Escuela",
    col: 1,
  },
  {
    name: "Dirección",
    col: 2,
  },
  {
    name: "Director",
    col: 3,
  },
  {
    name: "Grupo",
    col: 4,
  },
  {
    name: "Clave Materia",
    col: 5,
  },
  {
    name: "Nombre Materia",
    col: 6,
  },
  {
    name: "Lunes",
    col: 7,
  },
  {
    name: "Martes",
    col: 8,
  },
  {
    name: "Miercoles",
    col: 9,
  },
  {
    name: "Jueves",
    col: 10,
  },
  {
    name: "Viernes",
    col: 11,
  },
  {
    name: "Sábado",
    col: 12,
  },
  {
    name: "Domingo",
    col: 13,
  },
  {
    name: "Salón",
    col: 14,
  },
  {
    name: "T.Prof",
    col: 15,
  },
  {
    name: "T.Grupo",
    col: 16,
  },
  {
    name: "T.Asist",
    col: 17,
  },
  {
    name: "Módulo",
    col: 18,
  },
  {
    name: "Hrs Semana",
    col: 19,
  },
  {
    name: "Semanas",
    col: 20,
  },
  {
    name: "F.Alta",
    col: 21,
  },
  {
    name: "F.Baja",
    col: 22,
  },
  {
    name: "Fechas",
    col: 23,
  },
];

export const headers_pdf = [
  {
    name: "Campus",
    id: "Campus",
    col: 0,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Escuela",
    id: "Escuela",
    col: 1,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Dirección",
    id: "Dirección",
    col: 2,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Director",
    id: "Director",
    col: 3,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Grupo",
    id: "Grupo",
    col: 4,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Clave Materia",
    id: "Clave Materia",
    col: 5,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Nombre Materia",
    id: "Nombre Materia",
    col: 6,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Lunes",
    id: "Lunes",
    col: 7,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Martes",
    id: "Martes",
    col: 8,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Miercoles",
    id: "Miercoles",
    col: 9,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Jueves",
    id: "Jueves",
    col: 10,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Viernes",
    id: "Viernes",
    col: 11,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Sábado",
    id: "Sábado",
    col: 12,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Domingo",
    id: "Domingo",
    col: 13,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Salón",
    id: "Salón",
    col: 14,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "T.Prof",
    id: "T.Prof",
    col: 15,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "T.Grupo",
    id: "T.Grupo",
    col: 16,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "T.Asist",
    id: "T.Asist",
    col: 17,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Módulo",
    id: "Módulo",
    col: 18,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Hrs Semana",
    id: "Hrs Semana",
    col: 19,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Semanas",
    id: "Semanas",
    col: 20,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "F.Alta",
    id: "F.Alta",
    col: 21,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "F.Baja",
    id: "F.Baja",
    col: 22,
    width: "25%",
    align: "center",
    fn: null,
  },
  {
    name: "Fechas",
    id: "Fechas",
    col: 23,
    width: "25%",
    align: "center",
    fn: null,
  },
];
export const headersModal = [
  {
    name: "Día",
    col: 0,
  },
  {
    name: "Horario",
    col: 1,
  },
  {
    name: "Fecha",
    col: 2,
  },
];

export const headersCalendario = [
  {
    name: "Tipo Registro Asistencia",
    col: 0,
  },
  {
    name: "Modalidad",
    col: 1,
  },
  {
    name: "Campus",
    col: 2,
  },
  {
    name: "Escuela",
    col: 3,
  },
  {
    name: "Dirección",
    col: 4,
  },
  {
    name: "Director",
    col: 5,
  },
  {
    name: "Grupo",
    col: 6,
  },
  {
    name: "Clave Materia",
    col: 7,
  },
  {
    name: "Nombre Materia",
    col: 8,
  },
  {
    name: "Lun",
    col: 9,
  },
  {
    name: "Mar",
    col: 10,
  },
  {
    name: "Mier",
    col: 11,
  },
  {
    name: "Jue",
    col: 12,
  },
  {
    name: "Vie",
    col: 13,
  },
  {
    name: "Sab",
    col: 14,
  },
  {
    name: "Dom",
    col: 15,
  },
];

export const headersDetalleCalendario = [
  {
    name: "Clave Profesor",
    col: 0,
  },
  {
    name: "Nombre Profesor",
    col: 1,
  },
  {
    name: "Tipo Profesor",
    col: 2,
  },
  {
    name: "Fecha",
    col: 3,
  },
  {
    name: "Día",
    col: 4,
  },
  {
    name: "Inicia",
    col: 5,
  },
  {
    name: "Termina",
    col: 6,
  },
  {
    name: "Módulo",
    col: 7,
  },
  {
    name: "Horas por Semanas",
    col: 8,
  },
  {
    name: "Semanas",
    col: 9,
  },
  {
    name: "Fecha Alta",
    col: 10,
  },
  {
    name: "Fecha Baja",
    col: 11,
  },
];
